import React from 'react'
import { Container, CardDeskPreload } from '@rst/ui-ts'
import styled from 'styled-components'

export const CardDesk = ({ data }: any) => {
	return (
		<StyledContainer
			paddingTop={data.padding_top}
			paddingBottom={data.padding_bottom}
			align={data.align}
		>
			<CardDeskPreload {...data} />
		</StyledContainer>
	)
}

const StyledContainer = styled(Container)<{
	align: string
	paddingTop: number
	paddingBottom: number
}>`
	display: flex;
	margin: 0 auto;
	width: 100%;
	padding-top: ${p => `${p.paddingTop}px`};
	padding-bottom: ${p => `${p.paddingBottom}px`};
`
